import axios from "axios";
import { auth, getAppCheckToken } from "@/service/firebase";
import { managementApiBaseUrl } from "@/service/totemDeviceConfig";

const TIPOS_FOTO = new Set(["normal", "polaroid", "fotos_3x4"]);

function precosDoTipo(precos, tipoFoto) {
  if (!Array.isArray(precos)) return [];
  return tipoFoto ? precos.filter((preco) => preco.tipo === tipoFoto) : precos;
}

/** O agregado da API é do dia civil anterior de São Paulo. */
export function ontemEmSaoPaulo(agora = new Date()) {
  const partes = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(agora);
  const valor = (tipo) =>
    Number(partes.find((parte) => parte.type === tipo).value);
  return new Date(Date.UTC(valor("year"), valor("month") - 1, valor("day") - 1))
    .toISOString()
    .slice(0, 10);
}

/** Nunca mostra estrela para uma recomendação velha ou ausente no Totem. */
export function recomendacaoDisponivel(
  payload,
  precos,
  agora = new Date(),
  tipoFoto = null
) {
  if (tipoFoto !== null && !TIPOS_FOTO.has(tipoFoto)) return null;
  if (!payload || payload.data !== ontemEmSaoPaulo(agora)) return null;
  if (tipoFoto && payload.tipoFoto != null && payload.tipoFoto !== tipoFoto)
    return null;
  const precoId = payload.precoId;
  if (typeof precoId !== "string" || !precoId) return null;
  return precosDoTipo(precos, tipoFoto).some((preco) => preco.id === precoId)
    ? { precoId, fonte: payload.fonte === "MANUAL" ? "MANUAL" : "REDE" }
    : null;
}

export function precoRecomendadoDisponivel(
  payload,
  precos,
  agora = new Date(),
  tipoFoto = null
) {
  return recomendacaoDisponivel(payload, precos, agora, tipoFoto)?.precoId ?? null;
}

export async function buscarRecomendacaoItem(
  totemId,
  precos,
  agora = new Date(),
  tipoFoto = null
) {
  if (tipoFoto !== null && !TIPOS_FOTO.has(tipoFoto)) return null;
  const disponiveis = precosDoTipo(precos, tipoFoto);
  if (!totemId || !disponiveis.length) return null;
  try {
    const user = auth.currentUser;
    if (!user) return null;
    const [idToken, appCheckToken] = await Promise.all([
      user.getIdToken(),
      getAppCheckToken(),
    ]);
    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${idToken}`,
    };
    if (appCheckToken) headers["X-Firebase-AppCheck"] = appCheckToken;
    const resposta = await axios
      .create({
        baseURL: managementApiBaseUrl(),
        timeout: 8000,
      })
      .get(`/totem/device/recomendacao-item/${encodeURIComponent(totemId)}`, {
        headers,
        ...(tipoFoto ? { params: { tipoFoto } } : {}),
      });
    return recomendacaoDisponivel(resposta.data, disponiveis, agora, tipoFoto);
  } catch (_error) {
    // A falta de recomendação nunca impede a escolha e o pagamento.
    return null;
  }
}

export async function buscarPrecoMaisPedido(
  totemId,
  precos,
  agora = new Date(),
  tipoFoto = null
) {
  const recomendacao = await buscarRecomendacaoItem(
    totemId, precos, agora, tipoFoto
  );
  return recomendacao?.precoId ?? null;
}
